import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
export const _frontmatter = {
  "title": "Accessibility Statement",
  "layout": "content",
  "includeToc": true,
  "permalink": "/accessibility/"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "Accessibility-Statement",
      "style": {
        "position": "relative"
      }
    }}>{`Accessibility Statement`}</h1>
    <p>{`The Office of Natural Resources Revenue (ONRR) is committed to making its information and communication technologies accessible to individuals with disabilities by meeting or exceeding the requirements of Section 508 of the Rehabilitation Act of 1973, as amended. Section 508 is a federal law that requires agencies to provide individuals with disabilities access to electronic and information technology and data comparable to those who do not have disabilities, unless an undue burden would be imposed on the agency. To meet this commitment, our web templates have been designed to meet or exceed the Section 508 standards and to conform to the W3C Web Content Accessibility Guidelines (WCAG) 2.0, Level AA.`}</p>
    <br />
    <p>{`The Section 508 standards are the technical requirements and criteria that are used to measure conformance with the law. More information on Section 508 and the technical standards can be found at  `}<a parentName="p" {...{
        "href": "https://www.section508.gov/"
      }}>{`Section508.gov `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`. `}</p>
    <br />
    <p>{`The  `}<a parentName="p" {...{
        "href": "https://www.w3.org/TR/WCAG20/"
      }}>{`Web Content Accessibility Guidelines (WCAG) 2.0 `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` can be found at the  `}<a parentName="p" {...{
        "href": "https://www.w3.org/"
      }}>{`W3C website `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`.`}</p>
    <br />
    <p>{`ONRR follows the Department of Interior's `}<a parentName="p" {...{
        "href": "https://www.doi.gov/ocio/information_management/section-508-policies"
      }}>{`accessibility policies `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`.`}</p>
    <br />
    <p>{`If you have feedback or concerns related to the accessibility of any content on this website, or have ideas or comments that would help us improve the accessibility and usability of our website, email  `}<a parentName="p" {...{
        "href": "mailto:onrrweb@onrr.gov"
      }}>{`onrrweb@onrr.gov`}</a>{`. If applicable, please include the web address or URL and the specific problems you have encountered.`}</p>
    <br />
    <p>{`Correspondence for complaints can be addressed to:  `}</p>
    <br />
    <p>{`U.S. Department of the Interior `}<br />{`
Director, Office of Diversity, Inclusion and Civil Rights `}<br />{`
Mail Stop 4359 `}<br />{`
1849 C Street N.W. `}<br />{`
Washington, D.C. 20240 `}<br /></p>
    <br />
    <p>{`Contact the specific `}<a parentName="p" {...{
        "href": "https://www.doi.gov/ocio/section508-contacts#no-back"
      }}>{`Bureau/Office Section 508 Program Manager `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`for program-related questions or comments.`}</p>
    <br />
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.doi.gov/pmb/eeo"
      }}>{`Office of Diversity, Inclusion and Civil Rights `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` will apply the complaint procedures outlined in  43 CFR Part 17, Subpart E, which are established to implement Section 504 for resolving allegations of discrimination in a Federally conducted program or activity.`}</p>
    <h2 {...{
      "id": "Limitations-and-alternatives",
      "style": {
        "position": "relative"
      }
    }}>{`Limitations and alternatives`}</h2>
    <p>{`Despite our best efforts to ensure accessibility of this website, there may be some limitations. Below is a description of known limitations and potential solutions. `}<a parentName="p" {...{
        "href": "mailto:nrrd@onrr.gov"
      }}>{`Contact us`}</a>{` if you observe an issue not listed below.`}</p>
    <br />
    <p>{`Known limitations for Natural Resources Revenue Data:`}</p>
    <ul>
      <li parentName="ul">{`Data visualizations are not fully compliant. However, all data shown in the visualizations is in the downloadable compliant files.`}</li>
      <li parentName="ul">{`Some of the filter options are not keyboard accessible.`}</li>
      <li parentName="ul">{`If the user needs filtered data and cannot access those functions, they can `}<a parentName="li" {...{
          "href": "mailto:nrrd@onrr.gov"
        }}>{`contact us`}</a>{` with their request.`}</li>
    </ul>
    <h2 {...{
      "id": "Accessibility-resources",
      "style": {
        "position": "relative"
      }
    }}>{`Accessibility resources`}</h2>
    <h3 {...{
      "id": "DOI-Section-508-Program",
      "style": {
        "position": "relative"
      }
    }}>{`DOI Section 508 Program `}</h3>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://doi.gov/ocio/section508"
      }}>{`DOI Section 508 Program `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` manages and oversees the implementation of Section 508 of the Rehabilitation Act of 1973 and ensures information and communication technologies developed, procured, maintained and used by DOI is accessible to everyone. The DOI Section 508 website includes a list of `}<a parentName="p" {...{
        "href": "https://www.doi.gov/ocio/information_management/section-508-policies"
      }}>{`policies `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`, Bureau and Office `}<a parentName="p" {...{
        "href": "https://www.doi.gov/ocio/section508-contacts#no-back"
      }}>{`Section 508 contacts `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`, and `}<a parentName="p" {...{
        "href": "https://www.doi.gov/ocio/information_management/section-508-references"
      }}>{`Section 508-related references `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`. `}</p>
    <h3 {...{
      "id": "Telecommunications-relay-services",
      "style": {
        "position": "relative"
      }
    }}>{`Telecommunications relay services`}</h3>
    <p>{`Individuals who are deaf, deafblind, hard of hearing, or have a speech disability may dial 711 (TTY, TDD, or TeleBraille) to access telecommunications relay services. For more information visit the  `}<a parentName="p" {...{
        "href": "https://www.fcc.gov/consumers/guides/711-telecommunications-relay-service"
      }}>{`711 consumer guide `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`.`}</p>
    <h3 {...{
      "id": "FEDSHIREVETS-DOI-POC",
      "style": {
        "position": "relative"
      }
    }}>{`FEDSHIREVETS DOI POC `}</h3>
    <p><a parentName="p" {...{
        "href": "https://www.fedshirevets.gov/veterans-council/agency-directory/department-of-interior/"
      }}>{`FEDSHIREVETS DOI POC `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`: Schedule A Selective Placement Program Coordinator Points of Contact at DOI`}</p>
    <h3 {...{
      "id": "Reasonable-accommodations",
      "style": {
        "position": "relative"
      }
    }}>{`Reasonable accommodations`}</h3>
    <p>{`The DOI and its Bureaus/Offices provide `}<a parentName="p" {...{
        "href": "https://doi.gov/accommodations"
      }}>{`reasonable accommodations `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` for qualified individuals (employees and applicants for employment) with disabilities, unless doing so would cause an undue hardship. DOI provides Departmental guidance on reasonable accommodations in Personnel Bulletin (PB) 21-03 Processing Requests for Reasonable Accommodation for Individuals with Disabilities.`}</p>
    <h3 {...{
      "id": "Disability",
      "style": {
        "position": "relative"
      }
    }}>{`Disability`}</h3>
    <p><a parentName="p" {...{
        "href": "https://doi.gov/pmb/eeo/"
      }}>{`DOI's Office of Diversity, Inclusion and Civil Rights `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` provides information on civil rights and equal opportunity programs including  `}<a parentName="p" {...{
        "href": "https://doi.gov/pmb/eeo/Public-Civil-Rights"
      }}>{`disability-related topics `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`, and  `}<a parentName="p" {...{
        "href": "https://www.doi.gov/pmb/eeo/disability-and-religious-accommodations"
      }}>{`instructions for reasonable accommodations `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`.`}</p>
    <br />
    <p><a parentName="p" {...{
        "href": "https://www.dol.gov/agencies/odep"
      }}>{`Disability.gov `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` is a Federal government website that provides comprehensive information on disability programs and services in communities nationwide.`}</p>
    <h3 {...{
      "id": "Architectural-Barriers-Act-of-1968-42-USC-§§-4151--57",
      "style": {
        "position": "relative"
      }
    }}>{`Architectural Barriers Act of 1968 (42 U.S.C. §§ 4151--57)`}</h3>
    <p>{`The Architectural Barriers Act (ABA) requires access to facilities that are designed, built, altered, or leased with Federal funds. The Access Board is the federal agency responsible for enforcing the ABA. The Access Board's accessibility standards are available on the  `}<a parentName="p" {...{
        "href": "https://www.access-board.gov/aba/"
      }}>{`Access Board website `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{` along with  `}<a parentName="p" {...{
        "href": "https://www.access-board.gov/enforcement/"
      }}>{`information about filing a complaint `}<OpenInNewIcon style={{
          fontSize: 20
        }} mdxType="OpenInNewIcon" /></a>{`.`}</p>
    <br />
    <p>{`Last updated: August 8, 2024`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      